$(document).ready(function() { 
    var ndate = new Date();
    var hours = ndate.getHours();
    var message = hours < 12 ? 'Good Morning, ' : hours < 18 ? 'Good Afternoon, ' : 'Good Evening, ';
    $("span.day-message").html(message);
  

});

$(".toggle_list li a.active").each(function(i){
    $(this).closest(".sidebar-block").children("h4").addClass("active");
});


/* Handles header overlapping slideshow on mobile */

// Debounce function to optimize resize event
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// Function to adjust the margin of the under-menu element
function adjustMargin() {
    var header = document.getElementById('header');
    var headerHeight = header.offsetHeight + 'px';
    
    var underMenuElement = document.querySelector('.under-menu');
    if (underMenuElement) {
        underMenuElement.style.marginTop = headerHeight;
    }
}

// Adjust margin when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', adjustMargin);
// Adjust margin on window resize, but optimized with debounce
window.addEventListener('resize', debounce(adjustMargin, 100));

